import U from "../../../../_virtual/mapValues.js";
import X from "../../../../_virtual/every.js";
import { parseScale as Y, checkDomainOfScale as Z, getTicksOfScale as V, getBandSizeOfAxis as tt } from "./ChartUtils.js";
import { findChildByType as et } from "./ReactUtils.js";
import { getPercentValue as rt } from "./DataUtils.js";
import { Bar as nt } from "../cartesian/Bar.js";
function m(n) {
  "@babel/helpers - typeof";
  return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, m(n);
}
function it(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function L(n, t) {
  for (var r = 0; r < t.length; r++) {
    var e = t[r];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, D(e.key), e);
  }
}
function at(n, t, r) {
  return t && L(n.prototype, t), r && L(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function N(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(n);
    t && (e = e.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, e);
  }
  return r;
}
function u(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N(Object(r), !0).forEach(function(e) {
      A(n, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : N(Object(r)).forEach(function(e) {
      Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }
  return n;
}
function A(n, t, r) {
  return t = D(t), t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function D(n) {
  var t = ot(n, "string");
  return m(t) == "symbol" ? t : t + "";
}
function ot(n, t) {
  if (m(n) != "object" || !n) return n;
  var r = n[Symbol.toPrimitive];
  if (r !== void 0) {
    var e = r.call(n, t);
    if (m(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
var ft = function(t, r, e, i, o) {
  var c = t.width, h = t.height, l = t.layout, P = t.children, G = Object.keys(r), v = {
    left: e.left,
    leftMirror: e.left,
    right: c - e.right,
    rightMirror: c - e.right,
    top: e.top,
    topMirror: e.top,
    bottom: h - e.bottom,
    bottomMirror: h - e.bottom
  }, $ = !!et(P, nt);
  return G.reduce(function(q, I) {
    var a = r[I], f = a.orientation, M = a.domain, _ = a.padding, d = _ === void 0 ? {} : _, p = a.mirror, B = a.reversed, w = "".concat(f).concat(p ? "Mirror" : ""), s, g, j, k, y;
    if (a.type === "number" && (a.padding === "gap" || a.padding === "no-gap")) {
      var J = M[1] - M[0], S = 1 / 0, z = a.categoricalDomain.sort();
      if (z.forEach(function(Q, H) {
        H > 0 && (S = Math.min((Q || 0) - (z[H - 1] || 0), S));
      }), Number.isFinite(S)) {
        var R = S / J, O = a.layout === "vertical" ? e.height : e.width;
        if (a.padding === "gap" && (s = R * O / 2), a.padding === "no-gap") {
          var E = rt(t.barCategoryGap, R * O), C = R * O / 2;
          s = C - E - (C - E) / O * E;
        }
      }
    }
    i === "xAxis" ? g = [e.left + (d.left || 0) + (s || 0), e.left + e.width - (d.right || 0) - (s || 0)] : i === "yAxis" ? g = l === "horizontal" ? [e.top + e.height - (d.bottom || 0), e.top + (d.top || 0)] : [e.top + (d.top || 0) + (s || 0), e.top + e.height - (d.bottom || 0) - (s || 0)] : g = a.range, B && (g = [g[1], g[0]]);
    var W = Y(a, o, $), x = W.scale, K = W.realScaleType;
    x.domain(M).range(g), Z(x);
    var T = V(x, u(u({}, a), {}, {
      realScaleType: K
    }));
    i === "xAxis" ? (y = f === "top" && !p || f === "bottom" && p, j = e.left, k = v[w] - y * a.height) : i === "yAxis" && (y = f === "left" && !p || f === "right" && p, j = v[w] - y * a.width, k = e.top);
    var b = u(u(u({}, a), T), {}, {
      realScaleType: K,
      x: j,
      y: k,
      scale: x,
      width: i === "xAxis" ? e.width : a.width,
      height: i === "yAxis" ? e.height : a.height
    });
    return b.bandSize = tt(b, T), !a.hide && i === "xAxis" ? v[w] += (y ? -1 : 1) * b.height : a.hide || (v[w] += (y ? -1 : 1) * b.width), u(u({}, q), {}, A({}, I, b));
  }, {});
}, ct = function(t, r) {
  var e = t.x, i = t.y, o = r.x, c = r.y;
  return {
    x: Math.min(e, o),
    y: Math.min(i, c),
    width: Math.abs(o - e),
    height: Math.abs(c - i)
  };
}, pt = function(t) {
  var r = t.x1, e = t.y1, i = t.x2, o = t.y2;
  return ct({
    x: r,
    y: e
  }, {
    x: i,
    y: o
  });
}, F = /* @__PURE__ */ function() {
  function n(t) {
    it(this, n), this.scale = t;
  }
  return at(n, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = e.bandAware, o = e.position;
      if (r !== void 0) {
        if (o)
          switch (o) {
            case "start":
              return this.scale(r);
            case "middle": {
              var c = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + c;
            }
            case "end": {
              var h = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + h;
            }
            default:
              return this.scale(r);
          }
        if (i) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + l;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var e = this.range(), i = e[0], o = e[e.length - 1];
      return i <= o ? r >= i && r <= o : r >= o && r <= i;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new n(r);
    }
  }]);
}();
A(F, "EPS", 1e-4);
var bt = function(t) {
  var r = Object.keys(t).reduce(function(e, i) {
    return u(u({}, e), {}, A({}, i, F.create(t[i])));
  }, {});
  return u(u({}, r), {}, {
    apply: function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = o.bandAware, h = o.position;
      return U(i, function(l, P) {
        return r[P].apply(l, {
          bandAware: c,
          position: h
        });
      });
    },
    isInRange: function(i) {
      return X(i, function(o, c) {
        return r[c].isInRange(o);
      });
    }
  });
};
function ut(n) {
  return (n % 180 + 180) % 180;
}
var mt = function(t) {
  var r = t.width, e = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = ut(i), c = o * Math.PI / 180, h = Math.atan(e / r), l = c > h && c < Math.PI - h ? e / Math.sin(c) : r / Math.cos(c);
  return Math.abs(l);
};
export {
  F as ScaleHelper,
  bt as createLabeledScales,
  ft as formatAxisMap,
  mt as getAngledRectangleWidth,
  ut as normalizeAngle,
  pt as rectWithCoords,
  ct as rectWithPoints
};
